module.exports = __webpack_public_path__ + "img/back_width.4f96e090.png";